namespace SPA
{
	export namespace LRM
	{

		export class LandRegionMapCreator
			extends ui.tab.TabHTMLPresentation
		{

			private	Contractor:	number	= 1;
			private	Parent:			Wollmilch.Object.CustomerObject|null;
			private	Customer:		Wollmilch.CompanyObject;
			private	Form:				ui.Form.Form;

			public constructor( parent?: Wollmilch.Object.CustomerObject )
			{
				super();

				this.Parent		= parent || null;

				const customer	= app.getAuthenticationManager().getCompany();

				if ( customer == null )
				{
					throw new Error( 'NO_COMPANY_FOUND_?_LOGGED_IN' );
				}

				this.Customer	= customer;

				this.Form			= new ui.Form.Form(
					{
						action:					'object/new',
						method:					'POST',
						notSwitchable:	true,
						submit:					( method: ui.Form.FormMethod, url: string, parameter: ui.Form.IFormParameter ) =>
						{
							new Wollmilch.AJAX(
								{
									url,
									method,
									data:		parameter,
									on:
									{
										success: ( text: string ) =>
										{
											const obj = Wollmilch.jsonize( text );

											if ( !obj )
											{
												// TODO Notify Texte
												app.addNotify(
													{
														title:		[],
														body:			[],
														context:	'danger',
														timeout:	Number(app.getConfigValue("ToastTimeout"))
													}
												);

												return;
											}

											if ( !obj.success )
											{
												// TODO Notify Texte
												app.addNotify(
													{
														title:		[],
														body:			[],
														context:	'danger',
														timeout:	Number(app.getConfigValue("ToastTimeout"))
													}
												);
											}

											if ( obj.data )
											{
												// TODO Notify Texte
												app.addNotify(
													{
														title:		[],
														body:			[],
														context:	'success',
														timeout:	Number(app.getConfigValue("ToastTimeout"))
													}
												);

												return;
											}

											// TODO Notify Texte
											app.addNotify(
												{
													title:		[],
													body:			[],
													context:	'warning',
													timeout:	Number(app.getConfigValue("ToastTimeout"))
												}
											);
										}
									}
								},
								Wollmilch.AJAXCallbase_e.LRM
							).send();
						},
						invalid:				( inputs: ui.Form.BasicInputField[] ) => app.addNotify(
							{
								title: [ ui.$$.h( 4, app.getMessage( 'LandRegionMap.TITLE.NEW.invalid-notify-title-prefix' ) ), ui.$$.h( 4, app.getMessage( 'Form.missing_required_fields_title' ) ) ],
								body: [ ui.$$.p().text( app.getMessage( 'Form.missing_required_fields' ) ) ],
								context: 'danger',
								timeout: Number(app.getConfigValue("ToastTimeout"))
							}
						)
					}
				);

				this.Form.Initialize();

				if ( this.Parent ) { this.Form.Input( new ui.Form.HiddenTextInput( this.Parent.ToObject().ObjectNumber, 'parent' ) ); }
			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): LandRegionMapCreator
			{
				super.rebuild( root );

				this.Form.rebuild( this );

				const formrow = ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.Form.Root() );

				const boxl = new ui.Box.Box( true, { classes: [ 'clearfix' ] } );

				boxl.addTitle( app.getMessage( 'LandRegionMap.TITLE.NEW.order-data' ) );
				boxl.rebuild( ui.$$.div().addClass( 'col-xs-12 col-md-6' ).appendTo( formrow ) );

				boxl.append( ui.$$.p().addClass( 'form-required text-danger small-caps' ).text( app.getMessage( 'Aux.REQUIRED_INPUTS' ) ) );

				SPA.gui.form.SimpleStyledPostalAddress( this.Form, boxl, 'Address' ).forEach(
					( input ) =>
					{
						if ( this.Parent )
						{
							const adr	= this.Parent.ToObject().Object.Type === 'PostalAddressObject' ? ( this.Parent.ToObject().Object as Wollmilch.Object.IPostalAddressObject ).Address : null;

							if ( adr !== null ) { switch ( input.Name )
							{
								case 'Address.street':			input.value( adr.Street );			break;
								case 'Address.housenumber':	input.value( adr.HouseNumber );	break;
								case 'Address.postalcode':	input.value( adr.PostalCode );	break;
								case 'Address.city':				input.value( adr.City );				break;
								case 'Address.state':				input.value( adr.State );				break;
								case 'Address.country':			input.value( adr.Country );			break;
							}
							}
						}
					}
				);

				(() =>
				{
					const boxr			= new ui.Box.Box( true, { classes: [ 'clearfix' ] } );

					boxr.addTitle( app.getMessage( 'LandRegionMap.TITLE.NEW.billing-data' ) );

					boxr.rebuild( ui.$$.div().addClass( 'col-xs-12 col-md-6' ).appendTo( formrow ) );

					const company		= app.getAuthenticationManager().getCompany();

					new Wollmilch.AJAX(
						{
							url: 'customer/contractors/' + ( ( company as Wollmilch.CompanyObject ).ID ),
							on:
							{
								success: ( json: string ) =>
								{
									const obj = Wollmilch.jsonize( json );

									if ( !obj ) { return; }

									const options: {[key: string]: any} = {};

									const list = new SPA.gui.component.CheckableList( { multiple: false, required: true, name: 'Billing' } );

									obj.data.forEach(
										// TODO element korrekten Typ angeben
										( element: any ) =>
										{
											const customer =
											{
												Customer:				element.Customer.ID,
												Contractor:			element.Contractor.ID,
												CustomerNumber:	element.CustomerNumber
											};

											const	item					= list.add( customer, ( obj as {[key: string]: any} ).data.length === 1 );

											let	customerAdr		= '';
											let	contractorAdr	= '';

											element.Contractor.Address.forEach(
												( adr: any ) =>
												{
													if ( adr.KindOf === 'headquarters' )
													{
														contractorAdr	= '';

														( adr.display as string ).split( ',' ).forEach(
															(str) => contractorAdr	+= ( contractorAdr.length > 0 ? '<br>' : '' ) + str.trim()
														);
													}
												}
											);

											element.Customer.Address.forEach(
												( adr: any ) =>
												{
													if ( adr.KindOf === 'headquarters' || adr.KindOf === 'domicile' )
													{
														customerAdr	= '';

														( adr.display as string ).split( ',' ).forEach(
															(str) => customerAdr	+= ( customerAdr.length > 0 ? '<br>' : '' ) + str.trim()
														);
													}
												}
											);

											item.append(
												ui.$$.h(
													4,
													app.getMessage( 'Aux.BASIC.TRANSLATION.customer_number' ) + ': ' + element.CustomerNumber
												)
											);
											item.append(
												ui.$$.div().addClass( 'row' )
													.append(
														ui.$$.div().addClass( 'col-xs-12 col-md-6' )
															.append( ui.$$.p().text( element.Customer.Name ) )
															.append( ui.$$.p().append( customerAdr ) )
													)
													.append(
														ui.$$.div().addClass( 'col-xs-12 col-md-6' )
															.append( ui.$$.p().text( element.Contractor.Name ) )
															.append( ui.$$.address().append( contractorAdr ) )
													)
											);
										}
									);

									this.Form.Input( list );

									const fg = ui.$$.div().addClass( 'form-group' ).append(
										ui.$$.p().addClass( 'form-required text-danger small-caps' ).text( app.getMessage( 'Customer.REQUIRED_SELECTION' ) )
									).appendTo( boxr.Root() );

									list.rebuild( fg );
								}
							}
						},
						Wollmilch.AJAXCallbase_e.APIV1
					).send();
				})();

				const boxbtn	= new ui.Box.Box( false, { classes: [ 'clearfix' ] } ).rebuild( this.Form.Root() );

				boxbtn.append( $( this.Form.Buttons.submit.getElement() ).text( 'Jetzt kostenpflichtig beauftragen' ) );
				boxbtn.append( $( this.Form.Buttons.cancel.getElement() ).text( app.getMessage( 'Aux.ABORT_BTN' ) ).on( 'click', () => app.getGlobalTabControl().removeTab( this.m_Entry ) ) );

				return this;
			}

		}

	}
}
